function bandKeyOf(grade) {
  return grade?.age_band_key || `${grade?.age_min_days || ""}-${grade?.age_max_days || ""}`;
}

export function levelDisplayName(grade, language, contextGrades = null) {
  if (!grade) return "—";
  let base;
  if (grade.level_system === "age_band") {
    if (language === "ar" && grade.band_label_ar) base = grade.band_label_ar;
    else if (grade.band_label) base = grade.band_label;
    else if (language === "ar" && grade.name_ar) base = grade.name_ar;
    else base = grade.name || "—";
    if (contextGrades && base !== "—") {
      const key = bandKeyOf(grade);
      const shared = contextGrades.some(
        (g) => g && g.id !== grade.id && g.level_system === "age_band" && bandKeyOf(g) === key,
      );
      if (shared) return `${base} · ${grade.name}`;
    }
    return base;
  }
  if (language === "ar" && grade.name_ar) return grade.name_ar;
  return grade.name || "—";
}

export function levelWord(mode, language) {
  if (mode === "age_band") return language === "ar" ? "الفئة العمرية" : "Age Group";
  return language === "ar" ? "الصف" : "Grade";
}

export function levelSystemOf(user) {
  return user?.institution?.level_system === "age_band" ? "age_band" : "grade";
}
